import { render, staticRenderFns } from "./DynamicSlideItem.vue?vue&type=template&id=0c9683cf&scoped=true&"
import script from "./DynamicSlideItem.vue?vue&type=script&lang=js&"
export * from "./DynamicSlideItem.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSlideItem.vue?vue&type=style&index=0&id=0c9683cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9683cf",
  null
  
)

export default component.exports